




























































import FormContainer from "../mixins/form-container";
import Worker from "@/components/Worker.vue";
import Alert from "@/components/Alert.vue";
import PairRow from "@/components/PairRow.vue";
import { LoginResult } from "../services/sesion";
import SelectEva from "../components/SelectEva.vue";

export default FormContainer.extend({
  components: {
    Worker,
    Alert,
    PairRow,
    SelectEva,
  },
  data: () => ({
    email: "",
    password: "",
    selectEva: false,
    showPassword: false,
  }),

  methods: {
    async submit() {
      const result: LoginResult = await this.$store.dispatch("session/login", {
        email: this.email,
        password: this.password,
      });
      if (!result) {
        return;
      }
      if (result.token) {
        this.$router.push("/usuario");
        return;
      }

      let focusTarget: any = null;
      switch (result.code) {
        case "ERR_UNKNOWN_EMAIL":
          focusTarget = this.$refs.email;
          break;
        case "ERR_WRONG_PASSWORD":
          focusTarget = this.$refs.password;
          break;
      }
      if (focusTarget) {
        focusTarget.focus();
      }
    },
    updateEva(eva: any) {
      this.selectEva = eva;
    },
  },
});
